// Arregla un bug real detectado en produccion: si un cliente elegia
// "Anadir nombre bordado" en la ficha de producto, escribia un nombre y un
// color, y LUEGO volvia a elegir "Continuar sin personalizacion", los campos
// ocultos con esos datos NO se borraban del formulario. Si despues anadia al
// carrito con la opcion barata seleccionada, el pedido se guardaba con el
// precio de 80EUR pero arrastrando el nombre y color de antes.
//
// Este script NO modifica el script original de personalizacion (que sigue
// intacto), solo anade una limpieza adicional: cada vez que cambia una
// opcion, o justo antes de anadir al carrito, si la opcion elegida es
// "sin personalizacion", borra esos campos ocultos por completo.
(function () {
  function removeHiddenProperty(name) {
    document.querySelectorAll('[name="' + name + '"]').forEach(function (el) {
      el.remove();
    });
  }

  function normalizeText(text) {
    return (text || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getRadioText(radio) {
    var text = '';
    if (radio.value) text += ' ' + radio.value;
    if (radio.getAttribute('aria-label')) text += ' ' + radio.getAttribute('aria-label');
    if (radio.id) {
      var label = document.querySelector('label[for="' + radio.id + '"]');
      if (label) text += ' ' + label.textContent;
    }
    return normalizeText(text);
  }

  function isNoPersonalizationSelected() {
    var checked = document.querySelectorAll('input[type="radio"]:checked');
    for (var i = 0; i < checked.length; i++) {
      var text = getRadioText(checked[i]);
      if (
        text.indexOf('sin personalizacion') !== -1 ||
        text.indexOf('senza personalizzazione') !== -1 ||
        text.indexOf('sans personnalisation') !== -1 ||
        text.indexOf('sem personalizacao') !== -1 ||
        text.indexOf('without personalization') !== -1 ||
        text.indexOf('without personalisation') !== -1 ||
        text.indexOf('sense personalitzacio') !== -1
      ) {
        return true;
      }
    }
    return false;
  }

  function cleanupIfNotPersonalized() {
    if (isNoPersonalizationSelected()) {
      removeHiddenProperty('properties[Nombre bordado]');
      removeHiddenProperty('properties[Color bordado]');
    }
  }

  // Se ejecuta un poco despues del script original (que usa 100ms), para
  // limpiar justo despues de que se haya decidido mostrar/ocultar los campos.
  document.addEventListener(
    'change',
    function () {
      setTimeout(cleanupIfNotPersonalized, 180);
    },
    true
  );

  // Red de seguridad extra: tambien limpia justo antes de anadir al carrito,
  // por si el cambio de opcion no disparo el listener anterior a tiempo.
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('button[name="add"]');
      if (!btn) return;
      cleanupIfNotPersonalized();
    },
    true
  );

  cleanupIfNotPersonalized();
})();
